module.exports = __webpack_public_path__ + "static/publicArt-hero-7e9f3abba4fdb018e15bd5f50e2a7f49.jpg";